import { FunctionComponent } from "react";
import IconClose from "../Icons/IconClose/IconClose";
import Button from "./Button";

interface CloseButtonProps {
  onClick: Function;
  className?: string;
}

const CloseButton: FunctionComponent<CloseButtonProps> = ({
  onClick = () => {},
  className = "",
}) => {
  return (
    <Button
      onClick={() => onClick()}
      icon={<IconClose />}
      className={`btn-close ${className}`}
    />
  );
};

export default CloseButton;
